import { render } from "./MatricFrame.vue?vue&type=template&id=4fffd2af&scoped=true"
import script from "./MatricFrame.vue?vue&type=script&lang=js"
export * from "./MatricFrame.vue?vue&type=script&lang=js"

import "./MatricFrame.vue?vue&type=style&index=0&id=4fffd2af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fffd2af"]])

export default __exports__